import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';
import TreatmentGallery from '../components/TreatmentGallery';
import { imageUrl } from '../lib/images';

export default function BehandlingerPage() {
  const bookingUrl = 'https://djursmassage.app4.geckobooking.dk/site/booking.php?show=new_booking&icCode=69a506a6f06a0ca7022b880e8f6bcb65b11332&bId=11332&aDIfH=1&dTpl=1&sSToken=267bea05a53684a4a7d7ad2e6bae564a';

  return (
    <>
      <SEOHead
        title="Behandlinger & Terapi | Djurs Massage"
        description="Fysiurgisk massage, RAB zoneterapi, relax massage, fodpleje og cupping i Ryomgård. Grundig behandling tilpasset din krop. Book tid online."
        ogImage="https://assets.auxodev.dk/assets/5be3e3b2-e9a5-4c06-aea6-01d1054a5d99/djurs-massage-klinik-ryomgaard.jpg"
      />

      {/* Clean page header - NO container box, NO paragraph above heading */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-10 pb-6">
        <div className="max-w-3xl">
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-[#1E3A5F] font-serif leading-tight">
            Effektive behandlinger hos Djurs Massage
          </h1>
          <p className="text-slate-700 text-sm sm:text-base mt-3 leading-relaxed">
            Få en professionel og effektiv massage- eller zoneterapioplevelse i hjertet af Ryomgård. Hos Djurs Massage tilbyder vi et bredt udvalg af behandlinger, som er nøje tilpasset dine individuelle behov for at sikre en grundig, målrettet og seriøs behandling.
          </p>
          <div className="mt-5 flex flex-wrap items-center gap-3">
            <a
              href={bookingUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-4 py-2 sm:px-6 sm:py-2.5 bg-[#1E3A5F] text-white text-xs sm:text-sm font-semibold rounded-full hover:shadow-md transition-shadow"
            >
              <i className="fa-solid fa-calendar-check text-[#C9A770]" aria-hidden="true" />
              <span>Book tid nu</span>
            </a>
            {/* Secondary CTA: strictly NO background color and NO hover background */}
            <Link
              to="/prisliste"
              className="inline-flex items-center gap-2 px-4 py-2 sm:px-6 sm:py-2.5 bg-transparent hover:bg-transparent text-[#1E3A5F] hover:text-black border border-[#1E3A5F] text-xs sm:text-sm font-semibold rounded-full transition-colors"
            >
              <span>Se prisliste & klippekort</span>
              <i className="fa-solid fa-arrow-right text-[10px]" aria-hidden="true" />
            </Link>
          </div>

          {/* Praktisk information boks om lagen og håndklæde */}
          <div className="mt-6 p-4 sm:p-5 bg-white border-l-4 border-[#C9A770] border-y border-r border-[#E8E1D5] shadow-2xs">
            <div className="flex items-start gap-3">
              <i className="fa-solid fa-circle-info text-[#C9A770] text-lg mt-0.5 shrink-0" aria-hidden="true" />
              <div className="space-y-1 text-xs sm:text-sm text-slate-800">
                <strong className="block text-[#1E3A5F] font-serif text-sm sm:text-base">Praktisk information forud for din behandling</strong>
                <p>
                  Klinikken er en del af mit private hjem på Poppelvej 52 i Ryomgård, hvilket skaber rolige, hyggelige og trygge rammer om dit besøg.
                </p>
                <p className="font-semibold text-[#1E3A5F]">
                  Medbring venligst selv eget lagen og håndklæde til behandlingen – ved zoneterapi bedes du meget gerne medbringe et stort håndklæde.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Quick Navigation Anchor Bar */}
      <div className="bg-white border-y border-[#E8E1D5] sticky top-20 z-30 py-3">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 overflow-x-auto">
          <div className="flex items-center gap-4 text-xs font-semibold min-w-max text-slate-700">
            <a href="#fysiurgisk-massage" className="hover:text-[#1E3A5F] transition-colors">
              Fysiurgisk massage
            </a>
            <span>•</span>
            <a href="#zoneterapi" className="hover:text-[#1E3A5F] transition-colors">
              Zoneterapi
            </a>
            <span>•</span>
            <a href="#ems-traening" className="hover:text-[#1E3A5F] transition-colors font-bold text-[#C9A770]">
              EMS dragt
            </a>
            <span>•</span>
            <a href="#relax-massage" className="hover:text-[#1E3A5F] transition-colors">
              Relax massage
            </a>
            <span>•</span>
            <a href="#voksbehandling" className="hover:text-[#1E3A5F] transition-colors">
              Voksbehandling
            </a>
            <span>•</span>
            <a href="#pedicure-fodbehandling" className="hover:text-[#1E3A5F] transition-colors">
              Pedicure & Fodpleje
            </a>
            <span>•</span>
            <a href="#specialiserede-teknikker" className="hover:text-[#1E3A5F] transition-colors">
              Specialiserede teknikker
            </a>
          </div>
        </div>
      </div>

      {/* Clean content directly on container - NO card boxes wrapping headings and text */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16 divide-y divide-[#E8E1D5]">
        {/* BEHANDLING 1: Fysiurgisk massage */}
        <section id="fysiurgisk-massage" className="scroll-mt-32 py-12">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
            <div className="lg:col-span-7 space-y-4">
              <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-[#1E3A5F] font-serif">
                Fysiurgisk massage & Sportsmassage ved Tine
              </h2>

              {/* Synlig boks om Falck og sundhedsforsikring */}
              <div className="bg-[#F8F5EE] border-l-4 border-[#C9A770] p-4 text-xs sm:text-sm text-slate-800 space-y-1.5 shadow-2xs">
                <div className="font-bold text-[#1E3A5F] flex items-center gap-2">
                  <i className="fa-solid fa-shield-heart text-[#C9A770] text-base" aria-hidden="true" />
                  <span className="uppercase tracking-wider text-xs">RAB-godkendt massør · Eneste kvalitetsstempel for massører</span>
                </div>
                <p className="font-semibold text-[#1E3A5F]">
                  Tine er RAB-godkendt – dét der udløser sundhedsforsikringsdækning (Falck Healthcare & AP Pension)
                </p>
                <p className="text-slate-700">
                  RAB (Registreret Alternativ Behandler) er det eneste officielle kvalitetsstempel for massører i Danmark og sundhedsforsikringers krav for at dække behandlingen. Fysiurgisk massage er godkendt ved Falck Healthcare, og dækkes ligeledes ved AP Pensions sundhedsforsikring.
                </p>
              </div>

              <div className="space-y-3 text-slate-700 text-sm sm:text-base leading-relaxed">
                <p>
                  Fysiurgisk massage er en dybdegående massageform, der tager udgangspunkt i kroppens anatomi og fysiologi. Den fokuserer på at løsne spændinger i muskler og sener samt forbedre blodcirkulationen. Det kan give en mærkbar smertelindring i leddene, da muskler og sener slipper deres spænding og dermed ikke længere trækker i leddene.
                </p>
                <p>
                  <strong>Sportsmassage:</strong> Tine tilbyder desuden målrettet <strong>sportsmassage</strong> til både aktive atleter og motionister. Behandlingen forebygger overbelastningsskader, fjerner mælkesyre og fremmer hurtigere muskelrestitution.
                </p>
                <div className="pt-2 space-y-1.5 text-xs sm:text-sm text-slate-700">
                  <div className="font-bold text-[#1E3A5F]">Gavnlige effekter:</div>
                  <div className="flex items-start gap-2">
                    <i className="fa-solid fa-check text-[#C9A770] mt-1 shrink-0" aria-hidden="true" />
                    <span><strong>Løsning af muskel- og senespændinger:</strong> Hjælper med at afspænde vævet og reducere ømhed.</span>
                  </div>
                  <div className="flex items-start gap-2">
                    <i className="fa-solid fa-check text-[#C9A770] mt-1 shrink-0" aria-hidden="true" />
                    <span><strong>Øget blodcirkulation:</strong> Forbedrer ilt- og næringsstoftilførslen og hjælper med at fjerne affaldsstoffer.</span>
                  </div>
                  <div className="flex items-start gap-2">
                    <i className="fa-solid fa-check text-[#C9A770] mt-1 shrink-0" aria-hidden="true" />
                    <span><strong>Smertelindring i led:</strong> Ledsmerter lindres, da spændte muskler og sener slipper trækket i leddene.</span>
                  </div>
                  <div className="flex items-start gap-2">
                    <i className="fa-solid fa-check text-[#C9A770] mt-1 shrink-0" aria-hidden="true" />
                    <span><strong>Forbedret mobilitet:</strong> Løsner muskler og sener, hvilket giver bedre mobilitet, da det ikke længere trækker i leddene.</span>
                  </div>
                  <div className="flex items-start gap-2">
                    <i className="fa-solid fa-check text-[#C9A770] mt-1 shrink-0" aria-hidden="true" />
                    <span><strong>Stressreduktion:</strong> Har en beroligende effekt og reducerer kroppens stressniveau.</span>
                  </div>
                </div>
              </div>

              <div className="pt-3 flex flex-wrap items-center gap-3">
                <Link
                  to="/behandlinger/fysiurgisk-massage"
                  className="inline-flex items-center gap-1.5 px-4 py-2 bg-[#1E3A5F] text-white text-xs font-semibold rounded-full hover:shadow-md transition-shadow"
                >
                  <span>Læs mere om fysiurgisk massage</span>
                  <i className="fa-solid fa-arrow-right text-[10px]" aria-hidden="true" />
                </Link>
                <a
                  href={bookingUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-4 py-2 bg-transparent hover:bg-transparent text-[#1E3A5F] hover:text-black border border-[#1E3A5F] text-xs font-semibold rounded-full transition-colors"
                >
                  <i className="fa-solid fa-calendar-check text-[#C9A770]" aria-hidden="true" />
                  <span>Book tid</span>
                </a>
                <span className="text-xs font-bold text-[#1E3A5F]">Fast pris: 600 kr./time</span>
              </div>
            </div>

            <div className="lg:col-span-5 aspect-4/3 overflow-hidden border border-[#E8E1D5] bg-[#E8E1D5]">
              <img
                src={imageUrl('https://assets.auxodev.dk/assets/5be3e3b2-e9a5-4c06-aea6-01d1054a5d99/fysiurgisk-massage-rygbehandling.jpg', 'width=800,height=600,fit=cover,quality=85,format=auto')}
                alt="Fysiurgisk massage hos Djurs Massage"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <TreatmentGallery treatmentSlug="fysiurgisk-massage" />
        </section>

        {/* BEHANDLING 2: Zoneterapi */}
        <section id="zoneterapi" className="scroll-mt-32 py-12">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
            <div className="lg:col-span-7 space-y-4">
              <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-[#1E3A5F] font-serif">
                Zoneterapi ved Sophie (voksne & babyer)
              </h2>

              {/* Synlig boks om "Danmark" tilskud og sundhedsforsikring */}
              <div className="bg-[#F8F5EE] border-l-4 border-[#C9A770] p-4 text-xs sm:text-sm text-slate-800 space-y-1.5 shadow-2xs">
                <div className="font-bold text-[#1E3A5F] flex items-center gap-2">
                  <i className="fa-solid fa-shield-halved text-[#C9A770] text-base" aria-hidden="true" />
                  <span className="uppercase tracking-wider text-xs">RAB-godkendt zoneterapeut – Tilskud fra ”danmark”</span>
                </div>
                <p className="font-semibold text-[#1E3A5F]">
                  Tjek med din sundhedsforsikring om du er dækket!
                </p>
                <p className="text-slate-700">
                  Du kan opnå tilskud fra Sygeforsikringen ”danmark” samt gennem de fleste private sundhedsforsikringer til zoneterapi hos os.
                </p>
              </div>

              <div className="space-y-3 text-slate-700 text-sm sm:text-base leading-relaxed">
                <p>
                  En behandling foregår typisk, mens du ligger eller sidder behageligt tilbagelænet. Behandleren trykker blidt men præcist på forskellige punkter under dine fødder. Mange oplever det som en afslappende og behagelig behandling, der samtidig sætter gang i kroppens systemer.
                </p>
                <div className="pt-1">
                  <strong className="text-[#1E3A5F] block mb-1">Hvorfor vælge reflekszonebehandling?</strong>
                  <p>
                    Zoneterapi er en blid og naturlig reflekszonebehandling, som tager udgangspunkt i hele kroppen. Sophie udfører desuden også nænsom zoneterapi til babyer, som kan have stor gavn ved mavekneb, kolik eller uro.
                  </p>
                </div>
              </div>

              <div className="pt-3 flex flex-wrap items-center gap-3">
                <a
                  href={bookingUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-4 py-2 bg-[#1E3A5F] text-white text-xs font-semibold rounded-full hover:shadow-md transition-shadow"
                >
                  <i className="fa-solid fa-calendar-check text-[#C9A770]" aria-hidden="true" />
                  <span>Book zoneterapi</span>
                </a>
                <Link
                  to="/behandlinger/zoneterapi"
                  className="inline-flex items-center gap-1.5 px-4 py-2 bg-transparent hover:bg-slate-50 text-[#1E3A5F] border border-[#1E3A5F] text-xs font-semibold rounded-full transition-colors"
                >
                  <span>Læs mere om zoneterapi</span>
                  <i className="fa-solid fa-arrow-right text-[10px]" aria-hidden="true" />
                </Link>
                <span className="text-xs font-bold text-[#1E3A5F]">600 kr./time · RAB-godkendt</span>
              </div>
            </div>

            <div className="lg:col-span-5 aspect-4/3 overflow-hidden border border-[#E8E1D5] bg-[#E8E1D5]">
              <img
                src={imageUrl('https://assets.auxodev.dk/assets/5be3e3b2-e9a5-4c06-aea6-01d1054a5d99/zoneterapi-fodmassage-reflekspunkter.jpeg', 'width=800,height=600,fit=cover,quality=85,format=auto')}
                alt="Zoneterapi ved Sophie"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <TreatmentGallery treatmentSlug="zoneterapi" />
        </section>

        {/* BEHANDLING 3: Relax massage */}
        <section id="relax-massage" className="scroll-mt-32 py-12">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
            <div className="lg:col-span-7 space-y-4">
              <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-[#1E3A5F] font-serif">
                Relax Massage ved Diana
              </h2>
              <div className="space-y-3 text-slate-700 text-sm sm:text-base leading-relaxed">
                <p>
                  Har du brug for at koble fra og give kroppen en pause? Relax Massage er en rolig og afslappende massage med fokus på <strong>velvære, ro og afspænding</strong>. I modsætning til vores mere dybdegående og behandlingsorienterede massage er formålet her først og fremmest, at du får mulighed for at slappe af og nyde behandlingen.
                </p>
                <div className="space-y-1.5 text-xs sm:text-sm">
                  <p><strong>Relax Massage – 30 minutter:</strong> En afslappende behandling med fokus på ryg, nakke og skuldre.</p>
                  <p><strong>Relax Massage – 60 minutter:</strong> En afslappende kropsmassage, hvor der er god tid til at komme ned i tempo og finde ro.</p>
                  <p><strong>Gør oplevelsen ekstra afslappende:</strong> Du kan tilkøbe hovedbunds- og ansigtsmassage (+150 kr.).</p>
                </div>
              </div>

              <div className="pt-3 flex flex-wrap items-center gap-3">
                <Link
                  to="/behandlinger/relax-massage"
                  className="inline-flex items-center gap-1.5 px-4 py-2 bg-[#1E3A5F] text-white text-xs font-semibold rounded-full hover:shadow-md transition-shadow"
                >
                  <span>Læs mere om relax massage</span>
                  <i className="fa-solid fa-arrow-right text-[10px]" aria-hidden="true" />
                </Link>
                <a
                  href={bookingUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-4 py-2 bg-transparent hover:bg-transparent text-[#1E3A5F] hover:text-black border border-[#1E3A5F] text-xs font-semibold rounded-full transition-colors"
                >
                  <i className="fa-solid fa-calendar-check text-[#C9A770]" aria-hidden="true" />
                  <span>Book tid</span>
                </a>
                <span className="text-xs font-bold text-[#1E3A5F]">600 kr./time (30 el. 60 min)</span>
              </div>
            </div>

            <div className="lg:col-span-5 aspect-4/3 overflow-hidden border border-[#E8E1D5] bg-[#E8E1D5]">
              <img
                src={imageUrl('https://assets.auxodev.dk/assets/5be3e3b2-e9a5-4c06-aea6-01d1054a5d99/relax-massage-afslappende-rygmassage.png', 'width=800,height=600,fit=cover,quality=85,format=auto')}
                alt="Relax massage hos Djurs Massage"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <TreatmentGallery treatmentSlug="relax-massage" />
        </section>

        {/* BEHANDLING 4: Voksbehandling */}
        <section id="voksbehandling" className="scroll-mt-32 py-12">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
            <div className="lg:col-span-7 space-y-4">
              <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-[#1E3A5F] font-serif">
                Voksbehandling, Bikini & Threading
              </h2>
              <div className="space-y-3 text-slate-700 text-sm sm:text-base leading-relaxed">
                <p>
                  Professionel hårfjerning udført af vores kosmetolog Dianna. Vi tilbyder skånsom voksbehandling af blandt andet ben, arme, ryg og bikini udført med den rette voks.
                </p>
                <p>
                  Bemærk, at bryn og overlæbe ikke vokses, men udføres med præcis <strong>threading (trådning)</strong> for et yderst skånsomt og skarpt defineret resultat.
                </p>
                <p className="text-xs text-slate-600 italic">
                  * Vi anvender ikke engangsmateriale – husk venligst altid selv at medbringe eget lagen og håndklæde til behandlingen.
                </p>
              </div>

              <div className="pt-3 flex flex-wrap items-center gap-3">
                <Link
                  to="/behandlinger/voksbehandling"
                  className="inline-flex items-center gap-1.5 px-4 py-2 bg-[#1E3A5F] text-white text-xs font-semibold rounded-full hover:shadow-md transition-shadow"
                >
                  <span>Læs mere om voksbehandling</span>
                  <i className="fa-solid fa-arrow-right text-[10px]" aria-hidden="true" />
                </Link>
                <a
                  href={bookingUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-4 py-2 bg-transparent hover:bg-transparent text-[#1E3A5F] hover:text-black border border-[#1E3A5F] text-xs font-semibold rounded-full transition-colors"
                >
                  <i className="fa-solid fa-calendar-check text-[#C9A770]" aria-hidden="true" />
                  <span>Book tid</span>
                </a>
              </div>
            </div>

            <div className="lg:col-span-5 aspect-4/3 overflow-hidden border border-[#E8E1D5] bg-[#E8E1D5]">
              <img
                src={imageUrl('/_assets/voksbehandling-klinik.jpg', 'width=800,height=600,fit=cover,quality=85,format=auto')}
                alt="Voksbehandling hos Djurs Massage"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <TreatmentGallery treatmentSlug="voksbehandling" />
        </section>

        {/* BEHANDLING 5: Pedicure & Fodpleje */}
        <section id="pedicure-fodbehandling" className="scroll-mt-32 py-12">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
            <div className="lg:col-span-7 space-y-4">
              <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-[#1E3A5F] font-serif">
                Pedicure & Fodbehandling
              </h2>
              <div className="space-y-3 text-slate-700 text-sm sm:text-base leading-relaxed">
                <p>
                  Velplejede fødder giver øget velvære i hele kroppen. Vores kosmetolog Dianna tilbyder grundig pedicure og fodbehandling, der blødgør hård hud, plejer negle og neglebånd og efterlader fødderne friske og afslappede.
                </p>
                <p>
                  Behandlingen tilpasses den enkelte klient og udføres med stor omhu, præcision og høj hygiejnestandard.
                </p>
              </div>

              <div className="pt-3 flex flex-wrap items-center gap-3">
                <Link
                  to="/behandlinger/pedicure-fodbehandling"
                  className="inline-flex items-center gap-1.5 px-4 py-2 bg-[#1E3A5F] text-white text-xs font-semibold rounded-full hover:shadow-md transition-shadow"
                >
                  <span>Læs mere om pedicure & fodbehandling</span>
                  <i className="fa-solid fa-arrow-right text-[10px]" aria-hidden="true" />
                </Link>
                <a
                  href={bookingUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-4 py-2 bg-transparent hover:bg-transparent text-[#1E3A5F] hover:text-black border border-[#1E3A5F] text-xs font-semibold rounded-full transition-colors"
                >
                  <i className="fa-solid fa-calendar-check text-[#C9A770]" aria-hidden="true" />
                  <span>Book tid</span>
                </a>
              </div>
            </div>

            <div className="lg:col-span-5 aspect-4/3 overflow-hidden border border-[#E8E1D5] bg-[#E8E1D5]">
              <img
                src={imageUrl('https://assets.auxodev.dk/assets/5be3e3b2-e9a5-4c06-aea6-01d1054a5d99/pedicure-fodmassage-zoneterapi-behandling.jpeg', 'width=800,height=600,fit=cover,quality=85,format=auto')}
                alt="Pedicure og fodbehandling hos Djurs Massage"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <TreatmentGallery treatmentSlug="pedicure-fodbehandling" />
        </section>

        {/* BEHANDLING: EMS Dragt */}
        <section id="ems-traening" className="scroll-mt-32 py-12 border-t border-[#E8E1D5]">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
            <div className="lg:col-span-7 space-y-4">
              <div className="inline-flex items-center gap-2 px-2.5 py-0.5 bg-[#C9A770]/20 text-[#1E3A5F] text-xs font-bold uppercase tracking-wider">
                <i className="fa-solid fa-bolt text-[#C9A770]" aria-hidden="true" />
                <span>KUN dragt – ingen træning</span>
              </div>
              <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-[#1E3A5F] font-serif">
                EMS dragt hos Djurs Massage
              </h2>

              <div className="space-y-3 text-slate-700 text-sm sm:text-base leading-relaxed">
                <p>
                  Vores avancerede EMS dragt (Elektro-Myo-Stimulation) koster <strong>300 kr. for 30 minutter</strong> og er <strong>KUN dragt – ingen hård træning!</strong> Der er afsat en halv time, så der er god tid til i- og udstigning af dragten samt hygiejnisk rengøring. Vi tilbyder ikke gratis prøvetræning. Den kan anvendes alene for at styrke musklerne, eller i en yderst effektiv kombination med massage.
                </p>
                <p>
                  Dragten aktiverer muskulaturen dybt og skånsomt helt uden mekanisk led- eller senebelastning. Herudover er EMS-dragten enormt effektiv til <strong>smertelindring</strong>, da den aktiverer kroppens egne smertehæmmende stoffer, mens muskler og sener slipper deres spænding i leddene.
                </p>
                <div className="pt-1 space-y-1 text-xs sm:text-sm text-slate-700">
                  <div className="flex items-start gap-2">
                    <i className="fa-solid fa-check text-[#C9A770] mt-1 shrink-0" aria-hidden="true" />
                    <span><strong>KUN dragt, ingen træning:</strong> Slap af mens dragten skånsomt styrker musklerne.</span>
                  </div>
                  <div className="flex items-start gap-2">
                    <i className="fa-solid fa-check text-[#C9A770] mt-1 shrink-0" aria-hidden="true" />
                    <span><strong>Aktiverer smertehæmmende stoffer:</strong> Enormt effektiv til smertelindring i kroppen.</span>
                  </div>
                  <div className="flex items-start gap-2">
                    <i className="fa-solid fa-check text-[#C9A770] mt-1 shrink-0" aria-hidden="true" />
                    <span><strong>Aflaster leddene:</strong> Muskler og sener slipper deres stramme spænding.</span>
                  </div>
                  <div className="flex items-start gap-2">
                    <i className="fa-solid fa-check text-[#C9A770] mt-1 shrink-0" aria-hidden="true" />
                    <span><strong>Fleksibel brug:</strong> Kan benyttes alene eller kombineres med massage.</span>
                  </div>
                </div>
              </div>

              <div className="pt-3 flex flex-wrap items-center gap-3">
                <Link
                  to="/behandlinger/ems-traening"
                  className="inline-flex items-center gap-1.5 px-4 py-2 bg-[#1E3A5F] text-white text-xs font-semibold rounded-full hover:shadow-md transition-shadow"
                >
                  <span>Læs mere om EMS dragt</span>
                  <i className="fa-solid fa-arrow-right text-[10px]" aria-hidden="true" />
                </Link>
                <a
                  href={bookingUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-4 py-2 bg-transparent hover:bg-transparent text-[#1E3A5F] hover:text-black border border-[#1E3A5F] text-xs font-semibold rounded-full transition-colors"
                >
                  <i className="fa-solid fa-calendar-check text-[#C9A770]" aria-hidden="true" />
                  <span>Book tid til EMS dragt</span>
                </a>
                <span className="text-xs font-bold text-[#1E3A5F]">30 min. EMS dragt · 300 kr.</span>
              </div>
            </div>

            <div className="lg:col-span-5 aspect-4/3 overflow-hidden border border-[#E8E1D5] bg-[#E8E1D5]">
              <img
                src={imageUrl('/_assets/ems-traening-dragt-klinik.jpg', 'width=800,height=600,fit=cover,quality=90,format=auto')}
                alt="EMS dragt hos Djurs Massage"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </section>

        {/* BEHANDLING 6: Specialiserede teknikker */}
        <section id="specialiserede-teknikker" className="scroll-mt-32 py-12">
          <div className="space-y-4">
            <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-[#1E3A5F] font-serif">
              Specialiserede massagebehandlinger & teknikker
            </h2>
            <p className="text-slate-700 text-sm sm:text-base max-w-3xl leading-relaxed">
              Djurs Massage tilbyder et bredt udvalg af specialiserede teknikker, som kan benyttes under behandlingen efter dit individuelle behov:
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 pt-3">
              <div className="p-4 bg-white border border-[#E8E1D5]">
                <strong className="text-sm text-[#1E3A5F] block">Triggerpunktsmassage OG nåle</strong>
                <p className="text-xs text-slate-600 mt-1">Målrettet tryk på spændingsknuder og præcis brug af nåle for at fjerne udstrålende smerter.</p>
              </div>
              <div className="p-4 bg-white border border-[#E8E1D5]">
                <strong className="text-sm text-[#1E3A5F] block">Cupping massage</strong>
                <p className="text-xs text-slate-600 mt-1">Giver ikke store blå mærker. God effekt ved cellulitis/appelsinhud, bindevæv og cirkulation.</p>
              </div>
              <div className="p-4 bg-white border border-[#E8E1D5]">
                <strong className="text-sm text-[#1E3A5F] block">5 punkts øreakupunktur</strong>
                <p className="text-xs text-slate-600 mt-1">Nåle i specifikke ørepunkter til stress, smerter og mental ro.</p>
              </div>
              <div className="p-4 bg-white border border-[#E8E1D5]">
                <strong className="text-sm text-[#1E3A5F] block">Laser-/ultralydsbehandling</strong>
                <p className="text-xs text-slate-600 mt-1">Ikke-invasiv teknik der fremmer mikrocirkulation og dæmper inflammation.</p>
              </div>
              <div className="p-4 bg-white border border-[#E8E1D5]">
                <strong className="text-sm text-[#1E3A5F] block">Lymfedrænage</strong>
                <p className="text-xs text-slate-600 mt-1">Let massage der hjælper lymfesystemet med væske og affaldsstoffer.</p>
              </div>
              <div className="p-4 bg-white border border-[#E8E1D5]">
                <strong className="text-sm text-[#1E3A5F] block">Scraping</strong>
                <p className="text-xs text-slate-600 mt-1">Løsner bindevæv og øger blodcirkulation (eks. ligesom gua sha fra ansigtsbehandling/løft).</p>
              </div>
              <div className="p-4 bg-white border border-[#E8E1D5]">
                <strong className="text-sm text-[#1E3A5F] block">Kinesio taping</strong>
                <p className="text-xs text-slate-600 mt-1">Elastisk sportstape til støtte af led og muskler uden at hæmme bevægelse.</p>
              </div>
              <div className="p-4 bg-white border border-[#E8E1D5]">
                <strong className="text-sm text-[#1E3A5F] block">Dry needling</strong>
                <p className="text-xs text-slate-600 mt-1">Løsner muskelspændinger bl.a. ved hjælp af nervestimuli i musklen.</p>
              </div>
              <div className="p-4 bg-white border border-[#E8E1D5]">
                <strong className="text-sm text-[#1E3A5F] block">Ansigtsmassage</strong>
                <p className="text-xs text-slate-600 mt-1">Tillægsydelse (+150 kr.) til muskelbehandling eller opstramning.</p>
              </div>
            </div>

            <div className="pt-4 flex flex-wrap items-center gap-3">
              <Link
                to="/behandlinger/specialiserede-behandlinger"
                className="inline-flex items-center gap-1.5 px-4 py-2 bg-[#1E3A5F] text-white text-xs font-semibold rounded-full hover:shadow-md transition-shadow"
              >
                <span>Læs mere om de specialiserede teknikker</span>
                <i className="fa-solid fa-arrow-right text-[10px]" aria-hidden="true" />
              </Link>
              <Link
                to="/behandlingstyper"
                className="inline-flex items-center gap-2 px-4 py-2 bg-transparent hover:bg-transparent text-[#1E3A5F] hover:text-black border border-[#1E3A5F] text-xs font-semibold rounded-full transition-colors"
              >
                <span>Se alle behandlingstyper & teknikker</span>
                <i className="fa-solid fa-arrow-right text-[10px]" aria-hidden="true" />
              </Link>
            </div>
          </div>

          <TreatmentGallery treatmentSlug="special-behandlinger" />
        </section>
      </div>
    </>
  );
}
